import { combineReducers } from "redux";
import atlete from "./atlete-reducer";
//import timing from "./timing-reducer";
import tournaments from "./tournaments-reducer";
import teamgames from "./teamgames-reducer";

export default combineReducers({
  atlete,
  teamgames,
  //  timing,
  tournaments,
});
